export default __webpack_public_path__ + "static/media/logo-COM-desktop.bef4947f.svg";